export const mediaQuery = {
    computed: {
        mediaClass () {
            let mClass
            switch(this.$mq) {
                case 'mobile':
                    mClass= 'is-mobile'
                    break
                case 'tablet':
                    mClass= 'is-tablet'
                    break
                case 'desktop':
                    mClass= 'is-desktop'
                    break
                case 'widescreen':
                    mClass= 'is-widescreen'
                    break
                case 'fullhd':
                    mClass= 'is-fullhd'
                    break
                default:
                    mClass= 'is-mobile'
            }
            return mClass
        }
    }
}